import React, { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import './Popup.scss';

export default function Popup({
	buttonContent,
	children,
	position = 'bottom-right',
	open = false,
	onToggle,
}) {
	const popupRef = useRef(null);
	const buttonRef = useRef(null);

	const handleClickOutside = useCallback(
		(e) => {
			if (
				open &&
				popupRef.current &&
				!popupRef.current.contains(e.target) &&
				!buttonRef.current.contains(e.target)
			) {
				onToggle(false);
			}
		},
		[open, onToggle],
	);

	const handleToggle = (value) => () => onToggle(value);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, [handleClickOutside]);

	// Determine class based on prop
	const positionClass = `popup-${position}`;

	return (
		<>
			{open && <div className="popup-overlay" />}
			<div className="popup-container">
				<button
					ref={buttonRef}
					onClick={handleToggle(!open)}
					type="button"
				>
					{buttonContent}
				</button>

				{open && (
					<div
						ref={popupRef}
						className={`popup-box ${positionClass}`}
					>
						{children}
					</div>
				)}
			</div>
		</>
	);
}

Popup.propTypes = {
	buttonContent: PropTypes.node.isRequired,
	children: PropTypes.node.isRequired,
	position: PropTypes.oneOf([
		'bottom-right',
		'bottom-left',
		'top-right',
		'top-left',
		'right',
		'left',
	]),
	open: PropTypes.bool,
	onToggle: PropTypes.func.isRequired,
};
